import React from "react";

import Styled from "./BreadcrumbStyles";
import { ColorSAP, FONT_FAMILY } from "../../ontego-ui";
import { useTranslation } from "react-i18next";

export const Breadcrumb = (props) => {
    const { t } = useTranslation()

    const { id, style, handleChangeBreadcrumb } = props

    const stacks = props.stacks || []

    const handleStackClick = (index) => () => {
        if (handleChangeBreadcrumb) {
            handleChangeBreadcrumb("POP", stacks[index])
        } else {
            stacks[index].onClick()
        }
    }

    return (
        <Styled.BreadcrumbContainer
            style={style}
            id={id}
        >
            {stacks.map((stack, index) => {
                const typeOf = stack.typeOf

                return (
                    <React.Fragment
                        key={`stack${index}`}
                    >
                        {index !== 0 && (
                            <Styled.BreadcrumbLabel
                                fontFamily={FONT_FAMILY.PLUS_JAKARTA_SANS_REGULAR}
                                size={18}
                                color={ColorSAP.neutral[30]}
                                style={{
                                    cursor: index !== stacks.length - 1 && "pointer",
                                    marginLeft: 8,
                                    marginRight: 8,
                                    marginBottom: -5
                                }}
                            >
                                {` / `}
                            </Styled.BreadcrumbLabel>
                        )}
                        <Styled.BreadcrumbTextContainer
                            isLast={index === stacks.length - 1}
                            onClick={handleStackClick(index)}
                            style={{
                                marginTop: stack.typeOf !== "" ? -6 : 'auto'
                            }}
                        >
                            {(stack.typeOf !== "" || stack.typeof !== undefined) && (
                                <Styled.BreadcrumbTypographyHeader
                                    fontFamily={FONT_FAMILY.PLUS_JAKARTA_SANS_REGULAR}
                                    size={12}
                                    color={ColorSAP.neutral[30]}
                                >
                                    {typeOf ? typeOf : stack.type}
                                </Styled.BreadcrumbTypographyHeader>
                            )}
                            <Styled.BreadcrumbStackContainer isLast={index === stacks.length - 1}>
                                {stack.icon}
                                <Styled.BreadcrumbLabel
                                    fontFamily={FONT_FAMILY.PLUS_JAKARTA_SANS_REGULAR}
                                    size={18}
                                    color={index === stacks.length - 1 ? ColorSAP.neutral[100] : ColorSAP.neutral[30]}
                                    style={{
                                        cursor: index !== stacks.length - 1 && "pointer"
                                    }}
                                >
                                    {index === 0 ? stack.label : (stack.label === "Sonderfunktionen & Erweiterungen" ? t('scenario.sonderfunktionen') : t(`scenario.${stack.label}`))}
                                </Styled.BreadcrumbLabel>
                            </Styled.BreadcrumbStackContainer>
                        </Styled.BreadcrumbTextContainer>
                    </React.Fragment>
                )
            })}
        </Styled.BreadcrumbContainer>
    )
}

export default React.memo(Breadcrumb)